import { CartSheetTrigger } from '~/domains/cart/cart-sheet'
// import { HasExperiment } from '~/hooks/use-experiment'
import { UserMenu } from './user-menu'

export const AuthenticatedMenu = () => {
	return (
		<div className='flex items-center'>
			<div className='flex items-center gap-2 text-sm md:gap-6'>
				{/* <HasExperiment experimentId='carts-beta'> */}
				<CartSheetTrigger />
				{/* </HasExperiment> */}

				<UserMenu />
			</div>
		</div>
	)
}
